// eslint-disable-next-line import/prefer-default-export
export const peselMask = Array(11).fill(/\d/);

export type PeselMask = typeof peselMask;
